import React, { useEffect, useState } from "react";
import IconPreview from "../BuilderComponents/Preview/IconPreview";
import Button from "../FormComponents/Button";
import MaterialIcon from "../BuilderComponents/MaterialIcon";

const EditTableview = ({ layoutData, itemId, handleModalAction, tableRef }) => {
  const [headerData, setHeaderData] = useState(layoutData.current[itemId].config.headerData);
  const [bodyData, setBodyData] = useState(layoutData.current[itemId].config.bodyData);

  const deleteRow = (rowIndex) => {
    if (bodyData.length === 1) {
      setBodyData([[]]);
      settingLayoutData(headerData, []);

      return;
    }
    const newArray = bodyData.filter((_, index) => index !== rowIndex);
    setBodyData(newArray);
    settingLayoutData(headerData, newArray);
  };

  const deleteColumn = (e, colIndex) => {
    if (bodyData[0].length === 1) {
      setBodyData([[]]);
      settingLayoutData(headerData, []);

      return;
    }
    const newArray = bodyData.map((subArray) => {
      return [...subArray.slice(0, colIndex), ...subArray.slice(colIndex + 1)];
    });
    setBodyData(newArray);
    const newHeaderData = deleteHeaderName(colIndex, e);
    settingLayoutData(newHeaderData, newArray);
  };

  const deleteHeaderName = (i, e) => {
    e.stopPropagation();

    const newArray = headerData.filter((_, index) => index !== i);
    setHeaderData(newArray);
    return newArray;
  };

  const openTableEditPopup = (type, rowIndex, colIndex) => {
    if (type === "head") {
      handleModalAction({
        type: "tableview",
        modal_name: "Edit Tableview",
        i: itemId,
        data: {
          cell_type: "header",
          header_index: rowIndex
        }
      });
    }
    if (type === "body") {
      handleModalAction({
        type: "tableview",
        i: itemId,
        data: {
          cell_type: type,
          row_index: rowIndex,
          col_index: colIndex
        }
      });
    }
  };

  const addRowAndColumn = (direction) => {
    const array2D = JSON.parse(JSON.stringify(bodyData));
    const headArray = JSON.parse(JSON.stringify(headerData));

    if (direction === "row") {
      const row = [];
      for (let j = 0; j < bodyData[0].length; j++) {
        // Create a dummy object (you can modify this as needed)
        const dummyObject = {
          data_type: "text",
          data: "",
          data_key: "",
          className: {}
        };
        row.push(dummyObject);
      }
      array2D.push(row);
      // headArray.push(`head${row.length+1}`)
    } else if (direction === "column") {
      for (let i = 0; i < array2D.length; i++) {
        array2D[i].push({
          data_type: "text",
          data: "",
          data_key: "",
          icon: ""
        });
      }
      // headArray.push(`Header ${bodyData[0].length}`)
      headArray.push(`Header`);
    } else {
      array2D[0] = [
        {
          data_type: "text",
          data: "",
          data_key: "",
          icon: ""
        }
      ];
    }
    setBodyData(array2D);
    setHeaderData(headArray);
    settingLayoutData(headArray, array2D);
  };

  useEffect(() => {
    setHeaderData(layoutData.current[itemId].config.headerData);
    setBodyData(layoutData.current[itemId].config.bodyData);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [layoutData.current[itemId]]);

  const settingLayoutData = (newHeader, newBody) => {
    const newLayout = JSON.parse(JSON.stringify(layoutData.current));
    newLayout[itemId].config.headerData = newHeader;
    newLayout[itemId].config.bodyData = newBody;
    layoutData.current = newLayout;
  };

  return (
    <div className="table_view_edit">
      {bodyData.length === 0 || bodyData[0].length === 0 ? (
        <div>
          <Button variant="secondary" onClick={() => addRowAndColumn("first")}>
            Add block
          </Button>
        </div>
      ) : (
        <div className="tableView_add_table_container gap_2">
          <div className="tableView_add_table">
            {Array.from({ length: bodyData.length }, (_, rowIndex) => (
              <div className="tableView_add_table_row" key={"row" + rowIndex}>
                <MaterialIcon
                  name="delete"
                  className="builder_action_btn delete table_row_delete"
                  onClick={() => deleteRow(rowIndex)}
                />
                {Array.from({ length: bodyData[0].length }, (_, colIndex) => {
                  const cell = bodyData[rowIndex]?.[colIndex] || {};
                  const { className = {}, inline_style = {} } = cell;

                  const dynamicClassName = ["table_data_blocks", ...Object.values(className)].filter(Boolean).join(" ");

                  return (
                    <div key={"col" + colIndex} className="tableView_items flex_column">
                      {rowIndex === 0 && (
                        <MaterialIcon
                          name="delete"
                          className="builder_action_btn delete table_column_delete"
                          onClick={(e) => deleteColumn(e, colIndex)}
                        />
                      )}
                      {rowIndex === 0 && colIndex < headerData.length && (
                        <div
                          className="table_data_blocks justify_between"
                          onClick={() => openTableEditPopup("head", colIndex)}
                        >
                          {headerData[colIndex]}
                        </div>
                      )}
                      <div
                        className={dynamicClassName}
                        style={inline_style}
                        key={"column" + colIndex}
                        onClick={() => openTableEditPopup("body", rowIndex, colIndex)}
                      >
                        {bodyData[rowIndex]?.[colIndex]?.icon && (
                          <IconPreview icon={bodyData[rowIndex]?.[colIndex].icon || ""} />
                        )}

                        {!bodyData[rowIndex]?.[colIndex]?.data && !bodyData[rowIndex]?.[colIndex]?.data_key && "---"}
                        {bodyData[rowIndex]?.[colIndex]?.data_key
                          ? `${tableRef.current[bodyData[rowIndex]?.[colIndex]?.data_key]?.display}`
                          : `${bodyData[rowIndex]?.[colIndex]?.data}`}

                        {bodyData[rowIndex]?.[colIndex]?.button_list?.length > 0 &&
                          bodyData[rowIndex]?.[colIndex]?.button_list.map((btn, index) => (
                            <button key={index}>{btn.name}</button>
                          ))}
                      </div>
                    </div>
                  );
                })}
              </div>
            ))}

            <MaterialIcon name="add" className="builder_action_btn" onClick={() => addRowAndColumn("row")} />
          </div>
          <MaterialIcon name="add" className="builder_action_btn" onClick={() => addRowAndColumn("column")} />
        </div>
      )}
    </div>
  );
};

export default EditTableview;
